import { inject, Injectable } from '@angular/core';
import { Client } from '@api/client';
import { AuthService, ParsedUser } from '@services/auth.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProfileMediaAuthorService {
  private readonly client = inject(Client);
  private readonly authService = inject(AuthService);

  public async resolve(userId: number, parsedUser?: ParsedUser | null): Promise<ParsedUser | null> {
    if (parsedUser?.id === userId) {
      return parsedUser;
    }

    const currentUser: ParsedUser | null = this.authService.parsedUser;
    if (currentUser?.id === userId) {
      return currentUser;
    }

    try {
      const response = await firstValueFrom(this.client.userGet(String(userId)));
      return response.data?.id === userId ? ParsedUser.fromResponse(response.data) : null;
    } catch (error) {
      console.error('Error loading profile media author', { userId, error });
      return null;
    }
  }
}
